
<ion-grid>
  <ion-row>
    <ion-col>




<ion-card>
  <ion-card-header style="padding:0">
    <ion-toolbar color="primary">
      <ion-title>Importálás a Köznevelési Információs Rendszerből vagy Excelből</ion-title>
      <ion-buttons slot="end">
        <ion-button style="background: white; border-radius: 5px" [strong]="true"
           shape="round" color="secondary" size="small"><ion-icon slot="start" name="cloud-download"></ion-icon>Sablon letöltése</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-card-header>
  <ion-card-content style="margin:15px;">

<p style="text-align: justify;">A KIR rendszerből az alábbi módon letöltött táblázat a megfelelő: A KIR rendszerben az Alkalmazott keresése menüpontra kattintva, a Keresés ablakban a keresés találatait az Összes találat listába gombbal rakja át a Kérelemhez felvett személyek ablakba. Az ott található lista alján kattintson az Adatok exportálása gombra. A felugró ablakban válassza ki mindhárom listát (Személyes adatok, Jogviszony adatok, Képzettségek), majd töltse le a dokumentumot.</p>
       <p style="color:orangered;text-align: center;">Figyelem! A KIR excel fájl nem tartalmaz minden kötelező mezőt, azokat manuálisan kell pótolni a fájlban, vagy utólag az állomány menüben!</p>
<div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            
      <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" [(ngModel)]="overwrite" [disabled]="cdis">
        Létező felhasználók adatainak frissítése / felülírása</ion-checkbox>
          </div>
        </label>
      </div>
      <small>Ha be van pipálva, a rendszerben lévő tanulók adatait is frissíti a rendszer</small>
      <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" [(ngModel)]="generateKeycloakImport" [disabled]="cdis">
              Keycloak import fájl generálása</ion-checkbox>
          </div>
        </label>
      </div>
      <small>Felhasználónév: email cím, ha van, különben oktatási azonosító. Ideiglenes jelszó: születési dátum ÉÉÉÉHHNN formátumban.</small>
      <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" [(ngModel)]="szuloiFiokot" [disabled]="cdis">
              Gondviselői fiók generálása a tanulók mellé</ion-checkbox>
          </div>
        </label>
      </div>
      <small>Az <b>anyja neve</b> alapján, <code>&lt;oktatási azonosító&gt;G01</code> felhasználónévvel, a gyerek
        lakcímével. A KIR-ből csak ennyi adat van – ez a belépéshez és a gyerekhez kötéshez elég, a többi
        gondviselőt később fel lehet venni. Akinek már van ilyen fiókja, azt kihagyjuk.</small>
      <ion-input style="display:none;" label="dummy" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
        name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
<div class="container" appDnd (fileDropped)="onFileDropped($event)">
          <input type="file" accept=".xlsx, .xls" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event)" />
          <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
            <g fill="#3B454F" fill-rule="nonzero">
              <path
                d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
              <path
                d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
              <path
                d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
            </g>
          </svg>

          <h3>Húzza ide a fájlt (.xslx, .xls)</h3>
          <h3 style="    margin-bottom: 15px !important;">vagy</h3>
          <label for="fileDropRef">Tallózás</label>
        </div>
        <!-- Mit talált a KIR-olvasó: a mintasor és az ismételt fejléc kihagyása
             nem történhet némán, mert a sorszámok különben nem stimmelnének. -->
        <div class="alblokk" *ngIf="kirOlvasas && kirOlvasas.sorok.length">
          <b>KIR-fájl felismerve</b>
          <div class="alblokk-sugo">
            {{ kirOlvasas.sorok.length }} adatsor a {{ kirOlvasas.adatKezd + 1 }}. sortól.
            <span *ngIf="kirOlvasas.mintaDb">Kihagyva a KIR <b>{{ kirOlvasas.mintaDb }}</b> mintasora
              („Minta Géza") </span>
            <span *ngIf="kirOlvasas.ismeteltFejlec">és <b>{{ kirOlvasas.ismeteltFejlec }}</b> ismételt
              fejlécsor</span>
            <span *ngIf="kirOlvasas.mintaDb || kirOlvasas.ismeteltFejlec">– ezek nem tanulók.</span>
          </div>
        </div>

        <div class="files-list">
          <div class="single-file" *ngFor="let file of files; let i = index">
            <div class="file-icon" style="width: 50px">
              <img *ngIf="file?.name.slice(-3) == 'xls' ||file?.name.slice(-4) == 'xlsx'"
                src="assets/svg/excel-document-svgrepo-com.svg">
            </div>
            <div class="info">
              <h4 class="name">
                {{ file?.name }}
              </h4>
              <p class="size">
                {{ formatBytes(file?.size) }}
              </p>
              <app-progress [progress]="file?.progress"></app-progress>
            </div>

            <div class="delete" (click)="deleteFile(i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18">
                <path fill="#B1B1B1" fill-rule="nonzero"
                  d="M1 16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v10zm3.17-7.83a.996.996 0 0 1 1.41 0L7 9.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L8.41 11l1.42 1.42a.996.996 0 1 1-1.41 1.41L7 12.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L5.59 11 4.17 9.58a.996.996 0 0 1 0-1.41zM10.5 1L9.79.29C9.61.11 9.35 0 9.09 0H4.91c-.26 0-.52.11-.7.29L3.5 1H1c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5z" />
              </svg>
            </div>
          </div>
        </div>
        <!-- ═══ ENTRA (Azure AD) CSV: e-mail címek ══════════════════════════════
             A KIR-export nem tartalmaz e-mail címet, az csak az Entrában van meg.
             A kettőt az oktatási azonosító köti össze. -->
        <div class="alblokk">
          <b>E-mail cím és telefonszám összerendelése</b>
          <div class="alblokk-sugo">
            A tanulói KIR-export nem tartalmaz elérhetőséget. Két forrás jó ide: a KIR
            <b>„Tanulók elérhetőségi adataik"</b> táblázata, vagy az <b>Entra (Azure AD)</b>
            felhasználó-exportja. A rendszer az <b>oktatási azonosító</b> alapján fésüli hozzá az
            adatokat; az azonosító a belépési név előtagjaként is jó
            (pl. <code>73600725650&#64;iskola.hu</code>).
            <br><b>Ez köti össze a diákot a Microsoft-fiókjával:</b> belépéskor a rendszer az e-mail címre
            is illeszt, tehát amint a cím bekerül, a diák a saját fiókjával belépve megtalálja magát.
            <b>KIR-fájl nélkül is működik</b> – a már felvett tanulókhoz külön gombbal írja be a címeket.
          </div>
          <div class="alblokk-sor">
            <input type="file" id="entraFileRef" accept=".csv,.xlsx,.xls" (change)="onEntraFile($event)" />
            <span *ngIf="entraFajlNev" class="fajlnev">{{ entraFajlNev }} – {{ entraSorok.length }} sor</span>
            <ion-button *ngIf="entraFajlNev || graphForras" size="small" fill="clear" color="medium" (click)="entraTorol()">Elvet</ion-button>
          </div>

          <!-- GRAPH: az admin portál CSV-exportja fix oszlopkészletet ad, ami nincs benne
               (pl. az alkalmazotti azonosító), azt nem lehet vele kihozni. -->
          <div class="alblokk-sor">
            <b>vagy lekérés a Microsoft Graph API-ból:</b>
            <label>Csoport (nem kötelező):
              <input type="text" list="graphCsoportLista" [(ngModel)]="graphCsoport"
                     placeholder="pl. Diákok – üresen: teljes címtár" style="min-width:230px" />
              <datalist id="graphCsoportLista">
                <option *ngFor="let cs of graphCsoportok" [value]="cs.nev"></option>
              </datalist>
            </label>
            <ion-button size="small" fill="outline" (click)="graphCsoportokBetolt()">Csoportok betöltése</ion-button>
            <ion-button size="small" (click)="graphLekeres()" [disabled]="graphFut">
              <ion-spinner name="crescent" slot="start" *ngIf="graphFut"></ion-spinner>
              <ion-icon slot="start" name="cloud-download-outline" *ngIf="!graphFut"></ion-icon>
              {{ graphFut ? 'Lekérés…' : 'Felhasználók lekérése' }}
            </ion-button>
            <span *ngIf="graphForras" class="fajlnev">{{ graphForras }}</span>
          </div>
          <div class="alblokk-sugo" *ngIf="graphHiba" style="color:#c5221f">{{ graphHiba }}</div>
          <div class="alblokk-sugo">
            A Graph ugyanazt az app-regisztrációt használja, amit a profilkép-lekérés
            (Admin → Microsoft Graph) – <b>új alkalmazást nem kell létrehozni</b>. Ami kell hozzá:
            <code>User.Read.All</code> (csoportra szűrve <code>GroupMember.Read.All</code> is)
            <b>alkalmazás-szintű</b> engedély rendszergazdai jóváhagyással; a delegált engedély a gépi
            folyamathoz nem elég.
          </div>
          <div class="alblokk-sor" *ngIf="entraOszlopok.length">
            <label>Azonosító oszlop:
              <select [(ngModel)]="entraOktazonOszlop" (ngModelChange)="entraOsszefesul()">
                <option value="">– válassz –</option>
                <option *ngFor="let o of entraOszlopok" [value]="o">{{ o }}</option>
              </select>
            </label>
            <label>E-mail oszlop:
              <select [(ngModel)]="entraEmailOszlop" (ngModelChange)="entraOsszefesul()">
                <option value="">– válassz –</option>
                <option *ngFor="let o of entraOszlopok" [value]="o">{{ o }}</option>
              </select>
            </label>
            <label>Telefon oszlop:
              <select [(ngModel)]="entraTelefonOszlop" (ngModelChange)="entraOsszefesul()">
                <option value="">– nincs –</option>
                <option *ngFor="let o of entraOszlopok" [value]="o">{{ o }}</option>
              </select>
            </label>
            <label title="Ha a forrásban nincs oktatási azonosító, a név az egyetlen kapocs.">
              <input type="checkbox" [(ngModel)]="entraNevIllesztes" (ngModelChange)="entraOsszefesul()" />
              Illesztés névre is
            </label>
            <span *ngIf="excelData?.length" [style.color]="entraTalalat ? '#137333' : '#c5221f'">
              a betöltött fájlban: {{ entraTalalat }} / {{ excelData.length }} sorhoz van e-mail
            </span>
          </div>

          <!-- A MÁR felvett tanulók: ezeket nem az import írja, hanem egy célzott
               frissítés – egy e-mail cím miatt nem kell újraimportálni. -->
          <div *ngIf="entraOszlopok.length">
            <div class="alblokk-sor">
              <b *ngIf="entraParositas.length">{{ entraParositas.length }} már felvett tanulóhoz van új elérhetőség</b>
              <span *ngIf="!entraParositas.length" style="color:#5a6472">
                A rendszerben lévő tanulók közül egyikhez sincs beírandó új cím
                ({{ letezoTanulok.length }} tanuló, akiknek a címe már egyezik, nem jelenik meg itt).
              </span>
              <ion-button *ngIf="entraParositas.length" size="small" (click)="emailekMentese()" [disabled]="entraMentes">
                <ion-icon slot="start" name="mail-outline"></ion-icon>
                {{ entraMentes ? 'Mentés…' : 'Elérhetőségek beírása (' + entraParositas.length + ')' }}
              </ion-button>
            </div>
            <div class="terkep-burok" *ngIf="entraParositas.length">
              <table class="terkep">
                <thead><tr><th>Tanuló</th><th>Oktatási azonosító</th><th>Egyezés</th><th>Eddigi cím</th><th>Új cím</th><th>Telefon</th></tr></thead>
                <tbody>
                  <tr *ngFor="let p of entraParositas">
                    <td>{{ p.nev }}</td>
                    <td>{{ p.oktazon }}</td>
                    <td><span class="tag" [class.uj]="p.alap === 'név'">{{ p.alap }}</span></td>
                    <td [style.color]="p.regi ? '#8a6d00' : '#8a929e'">{{ p.regi || '– nincs –' }}</td>
                    <td>{{ p.uj || '– marad –' }}</td>
                    <td>{{ p.ujTel || '' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="alblokk-sugo" *ngIf="entraMentesEredmeny">
              Beírva: <b>{{ entraMentesEredmeny.frissitve }}</b>
              <span *ngIf="entraMentesEredmeny.valtozatlan">, változatlan: {{ entraMentesEredmeny.valtozatlan }}</span>
              <span *ngIf="entraMentesEredmeny.ismeretlen" style="color:#c5221f">,
                {{ entraMentesEredmeny.ismeretlen }} azonosító nem ehhez az intézményhez tartozik</span>
            </div>
          </div>
          <div class="alblokk-sugo" *ngIf="entraOszlopok.length">
            <span *ngIf="entraNevIllesztes && entraNevOszlopok.length">
              Névre illesztéshez használt oszlop(ok): <b>{{ entraNevOszlopok.join(', ') }}</b>.
            </span>
            <span *ngIf="entraNevIllesztes && !entraNevOszlopok.length">
              Névoszlopot nem találtunk a forrásban.
            </span>
            <span *ngIf="entraNevTalalat"> Ebből <b>{{ entraNevTalalat }}</b> egyezés a NÉV alapján jött.</span>
            <span *ngIf="entraTobbertelmu" style="color:#8a6d00">
              <b>{{ entraTobbertelmu }}</b> tanulónál több azonos nevű személy is szóba jött – ezeket
              szándékosan kihagytuk: felcserélt e-mail cím rosszabb, mint üres mező.
            </span>
          </div>
          <div class="alblokk-sugo" *ngIf="entraOszlopok.length && !entraTalalat && !entraParositas.length" style="color:#c5221f">
            Egyetlen sor sem illeszkedett. Ha a forrásban nincs oktatási azonosító (sok bérlőben
            nincs), hagyd bekapcsolva a névre illesztést, és ellenőrizd az e-mail oszlopot.
          </div>
        </div>

        <!-- ═══ ÉVFOLYAM-ELTOLÁS ÉS OSZTÁLY-HOZZÁRENDELÉS ═══════════════════════
             A KIR a MOSTANI állapotot adja: a következő tanév előkészítésekor a 9.
             évfolyamot 10.-ként kell rögzíteni. -->
        <div class="alblokk" *ngIf="terkepKulcsok.length">
          <b>Évfolyam és osztály hozzárendelése</b>
          <div class="alblokk-sugo">
            A KIR a <b>mostani</b> évfolyamot adja. Ha a következő tanévet készíted elő, add meg az
            eltolást (pl. <b>+1</b>): ez az évfolyamot <b>és az osztálynevet is</b> lépteti, mert a
            KIR mindkettőben hordozza a számot – „9. 9/A" → „10. 10/A", „9z" → „10z". Ami nem így lép
            (végzős évfolyam, betűjel nélküli osztály), azt soronként kézzel állítsd be: a kézi
            választást az eltolás <b>nem</b> írja felül.
          </div>
          <div class="alblokk-sor">
            <label>Évfolyam-eltolás:
              <input type="number" step="1" [(ngModel)]="evfolyamEltolas" (ngModelChange)="eltolasValt()"
                     style="width:70px" />
            </label>
            <span style="color:#666;font-size:12px">0 = a fájl szerint, +1 = mindenki egy évfolyammal feljebb</span>
            <ion-button size="small" fill="clear" (click)="terkepUjraszamol()">Javaslatok újraszámolása</ion-button>
          </div>
          <div class="terkep-burok">
            <table class="terkep">
              <thead><tr>
                <th>Fájlban</th><th>Eltolással</th><th>Cél osztály (a munkatanévben)</th><th>Évfolyam</th>
              </tr></thead>
              <tbody>
                <tr *ngFor="let kulcs of terkepKulcsok; trackBy: terkepTrack"
                    [class.nincs]="!osztalyTerkep[kulcs].osztaly">
                  <td>{{ kulcs }}</td>
                  <td>{{ osztalyTerkep[kulcs].eltolt }}
                    <span *ngIf="osztalyTerkep[kulcs].kezi" class="tag-kezi" title="Kézzel beállítva – az eltolás nem írja felül.">kézi</span>
                  </td>
                  <td>
                    <select [ngModel]="osztalyTerkep[kulcs].osztaly" (ngModelChange)="terkepValt(kulcs, $event)">
                      <option value="">– nincs (a sorok kimaradnak) –</option>
                      <option *ngFor="let o of osztaly" [value]="o.id">{{ o.osztaly }}</option>
                    </select>
                  </td>
                  <td>
                    <input type="number" step="1" style="width:60px" [ngModel]="osztalyTerkep[kulcs].evfolyam"
                           (ngModelChange)="terkepEvfolyamValt(kulcs, $event)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ELLENŐRZÉS. A hibás sorok eddig némán kimaradtak, és a képernyő sikert jelentett.
             Itt soronként látszik, mi hiányzik – így meg lehet javítani a táblázatot. -->
        <div *ngIf="ellenorzes" style="margin:10px 0;padding:10px;border-radius:8px;background:#f6f8fb">
          <b>Ellenőrzés:</b>
          <span style="color:#137333"> {{ ellenorzes.rendben }} teljes sor</span>
          <span *ngIf="ellenorzes.hianyos" style="color:#8a6d00">,
            {{ ellenorzes.hianyos }} hiányos sor (<b>ezek is bekerülnek</b>)</span>
          <span *ngIf="ellenorzes.blokkolt" style="color:#c5221f">,
            {{ ellenorzes.blokkolt }} sor azonosító nélkül (csak ezek maradnak ki)</span>
          <span *ngIf="ellenorzes.letezo" style="color:#8a6d00">,
            {{ ellenorzes.letezo }} már létező tanuló</span>
          <div style="font-size:12px;color:#666;margin-top:4px">
            A hiányzó adat <b>nem akadálya</b> az importnak: a tanuló bekerül, a mező üresen marad,
            és utólag pótolható. Akinek nincs osztálya hozzárendelve, az <b>besorolás nélkül</b> jön be –
            a besorolás az Osztály-besorolás képernyőn pótolható.
            A tanévben létező osztályok: <b>{{ osztalyNevek || '– nincs osztály felvéve –' }}</b>.
          </div>
          <div *ngIf="ellenorzes.tetelek.length" style="max-height:220px;overflow:auto;margin-top:8px">
            <table style="width:100%;font-size:12px;border-collapse:collapse">
              <thead><tr style="text-align:left">
                <th style="padding:2px 6px">Oktatási azonosító</th><th style="padding:2px 6px">Név</th>
                <th style="padding:2px 6px">Osztály</th><th style="padding:2px 6px">Mi hiányzik</th>
              </tr></thead>
              <tbody>
                <tr *ngFor="let h of ellenorzes.tetelek" style="border-top:1px solid #e3e7ee">
                  <td style="padding:2px 6px">{{ h.oktazon }}</td>
                  <td style="padding:2px 6px">{{ h.nev }}</td>
                  <td style="padding:2px 6px">{{ h.osztaly }}</td>
                  <td style="padding:2px 6px" [style.color]="h.blokkolo.length ? '#c5221f' : '#8a6d00'">
                    {{ (h.blokkolo.length ? h.blokkolo : h.hiany).join('; ') }}
                    <span *ngIf="!h.blokkolo.length" style="color:#5a6472"> — a sor bekerül</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="eredmeny" style="margin:10px 0;padding:10px;border-radius:8px;background:#eef7ee;font-size:13px">
          <b>Eredmény:</b>
          mentett tanuló: {{ eredmeny.tanulo?.affectedRows ?? 0 }},
          jogviszony: {{ eredmeny.tanulo_jogviszony?.affectedRows ?? 0 }},
          szolgáltatás: {{ eredmeny.tanulo_szolgaltatas?.affectedRows ?? 0 }}
          <span *ngIf="eredmeny.error" style="color:#c5221f">
            – hiba: {{ eredmeny.error?.sqlMessage || eredmeny.error?.message || eredmeny.error }}
          </span>
          <!-- Táblánkénti hiba: a többi rész eredménye ettől még érvényes. -->
          <div *ngIf="eredmeny.hibak?.length" style="margin-top:6px;color:#c5221f">
            <b>Ez a rész nem ment be:</b>
            <div *ngFor="let h of eredmeny.hibak">• {{ h }}</div>
          </div>
          <div *ngIf="szolgaltatasKihagyva" style="margin-top:6px;color:#8a6d00">
            {{ szolgaltatasKihagyva }} nyitott szolgáltatás kimaradt, mert a tanulónak nincs osztálya
            hozzárendelve – a szolgáltatás osztályhoz kötött adat. A tanuló maga bekerült.
          </div>
          <!-- Az adatbázis üresre cserélte a hiányzó kötelező mezőket: ez nem hiba,
               de tudni kell róla, mert az adat hiányos maradt. -->
          <div *ngIf="eredmeny.tanulo?.figyelmeztetes?.length" style="margin-top:6px;color:#8a6d00">
            <b>Hiányzó adatok (üresen mentve):</b>
            <div *ngFor="let w of eredmeny.tanulo.figyelmeztetes">• {{ w }}</div>
          </div>
        </div>

        <div *ngIf="szuloEredmeny" style="margin:10px 0;padding:10px;border-radius:8px;background:#eef4fb;font-size:13px">
          <b>Gondviselői fiókok:</b>
          létrehozva: {{ szuloEredmeny.szulo?.affectedRows ?? 0 }},
          gyerekhez kötve: {{ szuloEredmeny.tanulo_szulo?.inserted ?? 0 }}
          <span *ngIf="szuloEredmeny.tanulo_szulo?.skipped">
            (+{{ szuloEredmeny.tanulo_szulo.skipped }} kapcsolat már megvolt)</span>
          <span *ngIf="szuloEredmeny.error" style="color:#c5221f">
            – hiba: {{ szuloEredmeny.error?.sqlMessage || szuloEredmeny.error?.message || szuloEredmeny.error }}
          </span>
        </div>

        <ion-button style="background: white; border-radius: 5px" [strong]="true" expand="block" [disabled]="!cdis" (click)="uploadData()"
           shape="round" color="primary" id="open-loading"><ion-icon slot="start" name="cloud-upload" ></ion-icon>Importálás</ion-button>
           <ion-loading trigger="open-loading1" message="Adatok feltöltése folyamatban, ne zárja be az ablakot!" spinner="crescent"></ion-loading>
      </ion-card-content>
    </ion-card>
  </ion-col>
  
    </ion-row>
  </ion-grid>



<ngx-datatable 
          class="ngx-datatable cronomitnew"
          [rows]="excelData" [sortType]="SortType.single" [columnMode]="ColumnMode.force" 
           [selectionType]="SelectionType.checkbox" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column name="Oktatási azonosító" prop="Oktazon">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Oktatási azonosító</b>
              <span *ngIf="value">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              {{ row["Viselt név előtag"] }} {{ row["Viselt név vezetéknév"] }} {{ row["Viselt név keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Anyja neve">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Anyja neve</b>
              {{ row["Anyja neve előtag"] }} {{ row["Anyja neve vezetéknév"] }} {{ row["Anyja neve keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <!--ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0">
                <ion-icon slot="icon-only" name="search"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column-->
          <ngx-datatable-column name="Születési hely">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési hely</b>
              {{ row["Születési hely"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Születési dátum">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési dátum</b>
              {{ row["Születési dátum"] }}
            </ng-template>
          </ngx-datatable-column>
          <!--ngx-datatable-column name="Születési név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési név</b>
              {{ row["Születési név előtag"] }} {{ row["Születési név vezetéknév"] }} {{ row["Születési név keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Születési név">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Születési név</b>
              {{ row["Születési név előtag"] }} {{ row["Születési név vezetéknév"] }} {{ row["Születési név keresztnév"] }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="1. állampolgárság">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">1. állampolgárság</b>
              {{ row["1. állampolgárság"] }} 
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="2. állampolgárság">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">2. állampolgárság</b>
              {{ row["2. állampolgárság"] }} 
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Végzettség szintje">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Végzettség szintje</b>
              {{ row["Végzettség szintje"] }} 
            </ng-template>
          </ngx-datatable-column-->
          
        
        </ngx-datatable>
    
      
<div *ngIf="excelData">
  <h3>Uploaded Data:</h3>
  <pre>{{ excelData | json }}</pre>
</div>
